import type { PlatformReadPort } from '../core/platformReadTypes';

export interface PlatformReadService {
  getSettings(): Promise<Array<{ key: string; value: string | null }>>;
}

export function createPlatformReadService(port: PlatformReadPort): PlatformReadService {
  return {
    getSettings: () => port.getSettings(),
  };
}
